// extracted by mini-css-extract-plugin
module.exports = {"root_v4":"style_root_v4__rESJO"};